import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../root-store';
import { WalletCommonState } from './common-types';

export const selectWalletCommonState = (state: RootState): WalletCommonState =>
  state.features.walletStore.common;

export const getSelectedWalletSection:any = createDraftSafeSelector(
  selectWalletCommonState,
  (state: WalletCommonState) => {
    return state.selectedSection;
  }
);
